<template>
  <div id="app">
    <AppHeader class="border-bottom"/>
    <Loader v-if='isLoading' />
    <Dashboard v-if='isScreenDashboard'/>
    <Settings v-else-if='isScreenSettings'/>
    <About v-else-if='isScreenAbout'/>
    <Impressum v-else-if='isScreenImressum'/>
    <PrivacyPolicy v-else-if="isScreenPrivacyPolicy" />
    <LinkToAppModal />	
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import AppHeader from '@/components/AppHeader'
import LinkToAppModal from '@/components/LinkToAppModal'
import Dashboard from '@/components/client/Dashboard'
import About from '@/components/About'
import Settings from '@/components/settings/Settings'

//import Backend from '@/backend'

import { mapGetters } from 'vuex'
import _throttle from 'lodash/throttle'

export default {
  name: 'App',
  computed:{
     ...mapGetters(['currentStep', 'isLoading', 'isScreenDashboard', 
     'isScreenSettings', 'isScreenAbout', 'isScreenImressum', 'isScreenPrivacyPolicy']),
     
  },
  components: {
   Loader, AppHeader, Dashboard, Settings, About, LinkToAppModal
  },

  async mounted() {
  
     // DEBUG expose als exposedApp
    window.exposedApp = this
  },
  
}

</script>

<style>
#app {
  text-align: center;
  color: #2c3e50;
  /* margin-top: 3rem; */
}
</style>
